import { useProducts } from 'pages/inventory/hooks/useProducts'
import ProductTable from 'pages/inventory/components/product/ProductTable'
import ModalFormProduct from 'pages/inventory/components/product/ModalFormProduct'

export default function ProductHome() {
  const useProductsHook = useProducts()

  return (
    <div className="content-wrapper">
      {useProductsHook.toastContainer}
      <ProductTable
        currentPage={useProductsHook.currentPageProducts}
        statusFetch={useProductsHook.statusFetchProducts}
        limit={useProductsHook.limitPageProducts}
        onChangeLimit={useProductsHook.changeLimitPageProducts}
        onChangePage={useProductsHook.changeCurrentPageProducts}
        onChangeSearchKeyword={useProductsHook.changeSearchKeyword}
        onEnterSearchKeyword={useProductsHook.enterSearchKeyword}
        onFetch={useProductsHook.fetchProducts}
        onOpenCreate={useProductsHook.openCreateForm}
        onOpenEdit={useProductsHook.openEditForm}
        onSelectProductStatus={useProductsHook.changeFilterProductStatus}
        productStatus={useProductsHook.productStatus}
        products={useProductsHook.products}
        searchKeyword={useProductsHook.searchKeyword}
        totalRows={useProductsHook.totalRowsProducts}
      />
      {useProductsHook.isOpenModalForm ? (
        <ModalFormProduct
          isOpen={useProductsHook.isOpenModalForm}
          categories={useProductsHook.categoriesProduct}
          initialForm={useProductsHook.initialForm}
          isLoading={useProductsHook.statusForm === 'loading'}
          onClose={useProductsHook.closeForm}
          onSubmit={val => useProductsHook.submitForm(val)}
          stateForm={useProductsHook.stateForm}
        />
      ) : null}
    </div>
  )
}
